import { useCallback } from "react";
import { Class } from "@common/types/class";
import { useUpdateClassMutation } from "@api/class.api";

import { ClassForm, ClassSchema } from "./ClassForm";

export const RenameClassModal = ({
    classInstance,
    onHide,
}: {
    classInstance: Class;
    onHide: () => void;
}) => {
    const updateClass = useUpdateClassMutation();

    const onSubmit = useCallback(
        (classData: ClassSchema) =>
            updateClass.mutateAsync({
                params: {
                    id: classInstance.id,
                },
                body: {
                    label: classData.name,
                },
            }),
        [updateClass, classInstance.id],
    );

    return (
        <ClassForm
            classInstance={classInstance}
            onHide={onHide}
            onSubmitClass={onSubmit}
            isPending={updateClass.isPending}
            parentClassId={classInstance.parentClassId}
        />
    );
};
